import React, { Children } from 'react';
import CloseIcon from '../images/close.svg';

export default function OffCanvasModal({
  title,
  active,
  error,
  setActive,
  children,
}) {
  return (
    <div className='bg-black bg-opacity-50 fixed z-[999] w-[100%] h-full left-0 top-0 overflow-x-hidden'>
      <div className='w-full max-w-[45rem] bg-white absolute rounded-t-lg md:rounded-none bottom-0 h-[100%] md:h-[100%] right-0 max-h-screen overflow-y-scroll'>
        <div className='relative py-2 pt-14'>
          <div className='absolute bg-white w-[100%] top-0'>
            <div className='flex px-4 py-2 pt-4 md:px-8 md:py-4 justify-between items-center z-9 w-[100%]'>
              <h3 className='text-md font-bold tracking-[-.15px] capitalize'>
                {title}
              </h3>
              {error ? (
                <span className='error-text text center'>{error}</span>
              ) : null}
              <div
                className='bg-gray-100 px-2 py-2 rounded-md hover:bg-gray-200 transition-all cursor-pointer'
                onClick={() => setActive(false)}
              >
                <img src={CloseIcon} className='w-5 h-5' />
              </div>
            </div>
          </div>
          <div className='flex px-4 py-2 pt-4 md:px-8 md:py-4 md:pt-10 w-full updateloanproduct'>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
